
// document.addEventListener("DOMContentLoaded", function() {
//   // Initialize accordion functionality and Swiper for each section
//   document.querySelectorAll('.ingredients_info').forEach(section => {
//       // Accordion functionality
//       section.querySelectorAll('.ingredient_dt').forEach(dt => {
//           dt.addEventListener('click', function() {
//               const dd = this.nextElementSibling;
//               const isHidden = dd.getAttribute('aria-hidden') === 'true';
              
//               // Toggle aria-expanded on the clicked .ingredient_dt
//               const titleDiv = this.querySelector('.ingredient_dt_title');
//               const isExpanded = titleDiv.getAttribute('aria-expanded') === 'true';
//               titleDiv.setAttribute('aria-expanded', !isExpanded);
              
//               if (isHidden) {
//                   dd.setAttribute('aria-hidden', 'false');
//                   const fullHeight = dd.scrollHeight + 'px';
//                   dd.style.height = '0';
//                   dd.offsetHeight;
//                   dd.style.height = fullHeight;
//               } else {
//                   dd.setAttribute('aria-hidden', 'true');
//                   dd.style.height = dd.scrollHeight + 'px';
//                   dd.offsetHeight;
//                   dd.style.height = '0';
//               }
//           });
//       });

//       // Initialize Swiper only if needed and only on mobile for this specific section
//       function initSwiperIfNeeded() {
//           const sliderMobile = section.querySelector('.ingredients_slider_mobile');
//           const columns = section.querySelector('.ingredients_columns');
          
//           if (!sliderMobile || !columns) return;
          
//           // Check if we're on mobile and swiper isn't already initialized
//           if (window.innerWidth <= 481 && !sliderMobile.classList.contains('swiper')) {
//               // Add swiper classes
//               sliderMobile.classList.add('swiper', 'mySwiper');
//               columns.classList.add('swiper-wrapper');
//               section.querySelectorAll('.ingredient_column').forEach(column => {
//                   column.classList.add('swiper-slide');
//               });
              
//               // Create unique navigation selectors for this section
//               const sectionId = section.id || Math.random().toString(36).substr(2, 9);
//               sliderMobile.dataset.swiperId = sectionId;

              
//               // Initialize Swiper with unique navigation selectors for this section
//               const swiper = new Swiper(sliderMobile, {
//                   slidesPerView: 1.01,
//                   spaceBetween: 10,
//                   loop: true,
//                   navigation: {
//                       nextEl: sliderMobile.querySelector('.ingredients_next'),
//                       prevEl: sliderMobile.querySelector('.ingredients_prev'),
//                   },
//               });
//           } else if (window.innerWidth > 480 && sliderMobile.classList.contains('swiper')) {
//               // Remove swiper classes if we're not on mobile
//               sliderMobile.classList.remove('swiper', 'mySwiper');
//               columns.classList.remove('swiper-wrapper');
//               section.querySelectorAll('.ingredient_column').forEach(column => {
//                   column.classList.remove('swiper-slide');
//               });
              
//               // Remove navigation buttons
//               const navigation = sliderMobile.querySelector('.ingredients_navigation');
//               if (navigation) {
//                   navigation.remove();
//               }
              
//               // Destroy swiper instance if it exists
//               if (sliderMobile.swiper) {
//                   sliderMobile.swiper.destroy();
//               }
//           }
//       }
      
//       // Initial check
//       initSwiperIfNeeded();
      
//       // Check on window resize
//       window.addEventListener('resize', initSwiperIfNeeded);
//   });
// });
if (!customElements.get('ingredients-info-meta')) {
  class IngredientsInfoMeta extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initAccordion();
      this.initResponsiveSlider();
      window.addEventListener('resize', () => this.initResponsiveSlider());
    }

    initAccordion() {
      this.querySelectorAll('.ingredient_dt').forEach(dt => {
        dt.addEventListener('click', () => {
          const dd = dt.nextElementSibling;
          const titleDiv = dt.querySelector('.ingredient_dt_title');
          const isHidden = dd.getAttribute('aria-hidden') === 'true';

          // Toggle aria attributes
          titleDiv.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
          dd.setAttribute('aria-hidden', isHidden ? 'false' : 'true');

          // Smooth open/close animation
          if (isHidden) {
            dd.style.height = '0';
            dd.offsetHeight;
            dd.style.height = dd.scrollHeight + 'px';
          } else {
            dd.style.height = dd.scrollHeight + 'px';
            dd.offsetHeight;
            dd.style.height = '0';
          }
        });
      });
    }

    initResponsiveSlider() {
      const sliderMobile = this.querySelector('.ingredients_slider_mobile');
      const columns = this.querySelector('.ingredients_columns');
      if (!sliderMobile || !columns) return;

      const isMobile = window.innerWidth <= 767;
      const isSwiper = sliderMobile.classList.contains('swiper');

      if (isMobile && !isSwiper) {
        this.activateSwiper(sliderMobile, columns);
      } else if (!isMobile && isSwiper) {
        this.deactivateSwiper(sliderMobile, columns);
      }
    }

    activateSwiper(sliderMobile, columns) {
      sliderMobile.classList.add('swiper', 'mySwiper');
      columns.classList.add('swiper-wrapper');

      this.querySelectorAll('.ingredient_column').forEach(column => {
        column.classList.add('swiper-slide');
      });

      // Initialize Swiper
      const swiper = new Swiper(sliderMobile, {
        slidesPerView: 1.01,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: sliderMobile.querySelector('.ingredients_next'),
          prevEl: sliderMobile.querySelector('.ingredients_prev'),
        },
      });

      // Store swiper instance for cleanup
      sliderMobile.swiperInstance = swiper;
    }

    deactivateSwiper(sliderMobile, columns) {
      sliderMobile.classList.remove('swiper', 'mySwiper');
      columns.classList.remove('swiper-wrapper');

      this.querySelectorAll('.ingredient_column').forEach(column => {
        column.classList.remove('swiper-slide');
      });

      // Destroy existing Swiper instance safely
      if (sliderMobile.swiperInstance) {
        sliderMobile.swiperInstance.destroy(true, true);
        sliderMobile.swiperInstance = null;
      }
    }
  }

  customElements.define('ingredients-info-meta', IngredientsInfoMeta);
}
